module.exports = __webpack_public_path__ + "img/block-woah.18009d7e.jpg";